import Axios from 'axios';
import { getEndpointURL } from './config';
Axios.defaults.withCredentials = true;

const endpointURL = getEndpointURL();
const headers = { 'Content-Type': 'application/json; charset=utf-8' };

const GetPlanInfor = async () => {
    return Axios({
        method: 'POST',
        headers,
        data: {},
        url: `${endpointURL}/api/dashboard/get-plan-infor`
    })
}

const GetTodayTasks = async () => {
    return Axios({
        method: 'POST',
        headers,
        data: {},
        url: `${endpointURL}/api/dashboard/get-today-tasks`
    })
}

export {
    GetPlanInfor,
    GetTodayTasks,
};
